const props = {
  MuiUseMediaQuery: {
    noSsr: true,
  },
}

export default props
